import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import TextFrame from '../../../domain/entities/TextFrame';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexTextFramesSuccess: {
      const result = action.payload as PaginatedResult<TextFrame>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
